angular.module('iqxCore')
.controller('actionDialogDiaryCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc) {
  moment.locale('en_gb', {
    week : {
      dow : 1 // Monday is the first day of the week
    }
  })
  $scope.calendarView='month'

  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/NetOwnerCandidateDiary?pPersonID='+$scope.actiondialogparams.linkID+'&pStartDate='+moment().subtract(3, 'months').format('YYYY-MM-DD')+'&pEndDate='+moment().add(10, 'years').format('YYYY-MM-DD'),
    multiRow:true
    })

	function extractDateTime(dt,tm) {
    var d1=ApiSvc.StringToDate(dt)
    var t1=ApiSvc.StringToTime(tm)
    d1.setHours(t1.getHours())
    d1.setMinutes(t1.getMinutes())
    return d1
		}

  function extractType(row) {
    if (row.ActionType == 'confirmable_shift') {return 'info'}
    if (row.DiaryClass == 'Holiday' || row.DiaryClass == 'Unavailable') {return 'important'}
    if (row.DiaryClass == 'Available') {return 'success'}
    if (row.DiaryClass == 'Cancelled') {return 'special'}
    return 'inverse'
    }

  function extractTitle(row) {
    var rv=row.DiaryClass
    if (row.DiaryClass=='Working') {rv=rv+' at '+row.Description}
    if (row.DiaryStatus=='Provisional') {rv='Provisionally '+rv}
    return rv
  }

  $scope.slide=function(n){
    if(n){
      $scope.calendarDate = moment($scope.calendarDate).add(n, $scope.calendarView).toDate()
    }
  }

  $scope.changeDate=function(myScope,changed) {
    if (myScope.theRecord.xDateFrom>myScope.theRecord.xDateTo) {
      if (changed=='from') {
        myScope.theRecord.xDateTo=myScope.theRecord.xDateFrom
      } else {
        myScope.theRecord.xDateFrom=myScope.theRecord.xDateTo
      }
    }
  }

  $scope.callContactNumber=function(n){
    window.open("tel:"+n)
  }

  $scope.eventClicked=function(evt) {
    $scope.showMoreInfo=false

    if (evt.DiaryClass == 'Working' && $scope.isSwitchedOn('ASSIGNMENTDETAILS')) {
      $scope.showMoreInfo=true
      $scope.lineID=evt.DiaryID.replace("Shift_","")
    }

    var theChoice=''
    var desc=evt.Description

    if (moment(evt.startsAt).format("HH:mm") != '00:00' || moment(evt.endsAt).format("HH:mm") != '00:00') {
      var times=moment(evt.startsAt).format('DD/MM/YYYY HH:mm')+' to '+moment(evt.endsAt).format('HH:mm')
    } else {
      var times=moment(evt.startsAt).format('DD/MM/YYYY')
    }

    var choices=[{desc:'Close',type:'primary',code:''}]
    if (evt.ActionType=='confirmable_shift') {
      $scope.xCaption='Provisional Shift'
      choices=[{desc:"I'm available",type:"success",code:'F'},
               {desc:"I'm NOT available",type:"danger",code:'C'},
               {desc:"I don't yet know",type:"primary",code:''}]
    } else if (evt.ActionType=='cancelled_shift') {
      $scope.xCaption='Cancelled Shift'
    } else {
      $scope.xCaption='Working'
    }

    var data={ContactName:evt.ContactName,ContactNumber:evt.ContactNumber,desc:desc,times:times,address:evt.Address,map:evt.MapQuery,choices:choices}

    return FormSvc.modalInfo($scope,'diaryInfo',data)
    .then(function(choice) {
      theChoice=choice
      if (theChoice=='C') {   // Cancel is irreversible - allow escape
        return ApplicationSvc.queryMessage('Please Confirm','Reject shift?')
        }  // Other cases simply return yield a fulfilled promise of undefined value which continues the chain
        if (theChoice=='D') {   // Cancel is irreversible - allow escape
          return ApplicationSvc.queryMessage('Please Confirm','Delete Availability?')
          }  // Other cases simply return yield a fulfilled promise of undefined value which continues the chain
      })
    .then(function() {
      if (theChoice) {return $scope.exec('call/NetCandidateDiaryAdd',{pState:theChoice,IDCode:evt.DiaryID.substring(6)})}
    })
    .then(function() {
      switch (theChoice) {
        case 'F':
          evt.ActionType=''
          evt.type='inverse'
          evt.DiaryStatus=''
          evt.title='Working at '+evt.Description
          break
        case 'C':
          $scope.deleteEvent(evt.DiaryID)
          break
        case 'D':
          $scope.deleteEvent(evt.DiaryID)
          break
      }
      })
    .catch(function (err) {
      if (typeof err === 'undefined' || err == 'escape key press' ||  err == 'backdrop click') { // Escape Key pressed or backdrop cancel!

      } else if (err) {ApplicationSvc.showMessage('Error',err,true)}
      })
  }

  $scope.viewChangeClicked=function(calendarDate, calendarNextView){
    return false   // We don't want to change view other than by one of the buttons
  }

  $scope.showKey=function(){
    var choices=[{desc:'Close',type:'primary',code:''}]
    var data={choices:choices}
    FormSvc.modalInfo($scope,'diaryKey',data)
  }

  $scope.load=function() {
    return $scope.fetch()
    .then(function() {
      $scope.events=[]
      angular.forEach($scope.theRecords,function(row) {
        $scope.events.push({title:extractTitle(row),
                            type:extractType(row),
                            startsAt:extractDateTime(row.DateFrom,row.TimeFrom || '00:00'),
                            endsAt:extractDateTime(row.DateTo,row.TimeTo || '23:59'),
                            editable:(row.ActionType=='deleteable_shift'),
                            deletable:(row.ActionType=='deleteable_shift'),
                            DiaryID:row.DiaryID,         // Shift_tempshiftid or Employment_employmentid
                            ActionType:row.ActionType,   // deleteable_shift, confirmable_shift, cancelled_shift
                            DiaryClass:row.DiaryClass,   // Holiday, Available, Unavailable, Cancelled, Working
                            cssClass:row.DiaryClass,     // Holiday, Available, Unavailable, Cancelled, Working
                            DiaryStatus:row.DiaryStatus, // Provisional or blank
                            Description:row.Description, // company.name if Working
                            Address:row.Address,         // company address (comma sep) if working
                            MapQuery:row.MapQuery,       // for google maps
                            AllDay:(row.TimeFrom?false:true),
                            ContactName:row.ContactName,
                            ContactNumber:row.ContactNumber
                            })
        })
      $scope.theRecords=[] // Free the memory
      })
      .then(function(){
        $scope.eventsList=angular.copy($scope.events)
        angular.forEach($scope.eventsList, function(event, key){
          $scope.eventsList[key].eventMonthYear=moment(event.startsAt).format("MMMM YYYY")
        })
        $scope.eventMonthyearNow=moment().format("MMMM YYYY")
      })
    }

  $scope.events=[]
  $scope.cellIsOpen=true
  $scope.calendarDate=new Date() // today

  $scope.load()

})
